export const MERGE_BLOCK_NUMBER = 15537394;
export const MERGE_SUPPLY = 120521140.9246213;
export const MERGE_TIMESTAMP = new Date("2022-09-15T06:42:59Z");
export const TOTAL_TERMINAL_DIFFICULTY = 5.875e22;
